module.exports = __webpack_public_path__ + "img/c50fd31.png";